/// <reference path="../_all.ts" />

module misc {

  imageLazyLoadDirective.$inject = ['$parse'];
  export function imageLazyLoadDirective(
    $parse: ng.IParseService
  ): ng.IDirective {

    return {
      restrict: 'A',
      link: function (scope: any, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        const observer = new IntersectionObserver(loadImg, { rootMargin :  '500px' });
        const img = angular.element(element)[0];
        observer.observe(img);
        
        function loadImg(changes) {
          changes.forEach(change => {
            if (change.intersectionRatio > 0) {
              change.target.src = attr.imageLazyLoad;
            }
          })
        }
      }
    }

  }

}